// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"5b21c692","279":"c663638a","361":"2bc283a8","452":"27e3f964","754":"d3b7ca06"}[chunkId] + ".css";
};